module.exports = __webpack_public_path__ + "img/L_310_0.314b6885.png";